import type { QueryEntity } from '@/sections/insights/queryBuilder/entities/types';

import { adObjectEntity } from './index';

/**
 * ADComputer entity - alias of ADObject
 * Represents Active Directory computer objects
 */
export const adComputerEntity: QueryEntity<unknown> = {
  ...adObjectEntity,
  primaryLabel: { actual: 'ADComputer', display: 'AD Computer' },
  alias: 'ADObject',
};
